import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NameCasePipe } from './name-pipe';
import { TimerPipe } from './timer-pipe';
import { ConvertUTCtoESTDatePipe } from './convertUTCtoESTDate-pipe';
@NgModule({
  declarations: [NameCasePipe, TimerPipe, ConvertUTCtoESTDatePipe],
  imports: [
    CommonModule
  ],
  exports: [NameCasePipe, TimerPipe, ConvertUTCtoESTDatePipe]
})
export class CustomPipesModule { }
